import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import './globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
